import React, { useEffect, useState, useRef } from "react";
import { Icon } from "@iconify/react";
import Div from "../Div";
import Spacing from "../Spacing";
import VideoModal from "../VideoModal";
import SectionHeading from "../SectionHeading";
import { pageTitle } from "../../helper";
import "./TiaPatyHome.scss";
import MovingText2 from "../MovingText/MovingText2";
import PortfolioSlider from "../Slider/PortfolioSlider";

export default function TiaPatyHome() {
  pageTitle("Tia Paty - Psicomotricidade");
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);

  // Backgrounds de nuvens
  const bgObjetivo = {
    backgroundImage: `url(/images/tia-paty/BG/Prancheta-5.png)`,
    backgroundSize: 'cover, 40%',
    backgroundPosition: 'top right',
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const serviceData1 = [
    {
      title: "CONFIANÇA",
      href: "#",
    },
    {
      title: "DEDICAÇÃO",
      href: "#",
    },
    {
      title: "RECUPERAÇÃO",
      href: "#",
    },
  ];

  const serviceData2 = [
    {
      title: "AFETO",
      href: "#",
    },
    {
      title: "MOVIMENTO",
      href: "#",
    },
    {
      title: "AUTONOMIA",
      href: "#",
    },
  ];

  // Dados Vídeos
  const videosData = [
    {
      videoSrc: "/images/tia-paty/reels-tia-paty-1.mp4",
      bgUrl: "/images/tia-paty/reels-tia-paty-1.png",
    },
    {
      videoSrc: "/images/tia-paty/reels-tia-paty-2.mp4",
      bgUrl: "/images/tia-paty/reels-tia-paty-2.png",
    },
    {
      videoSrc: "/images/tia-paty/reels-tia-paty-3.mp4",
      bgUrl: "/images/tia-paty/reels-tia-paty-3.png",
    },
  ];

  return (
    <>
      {/* Hero Section com Vídeo */}
      <Div className="cs-video_block_1_wrap">
        <Div className="tp-video-hero">
          <video
            ref={videoRef}
            className="tp-hero-video"
            autoPlay
            loop
            muted
            playsInline
          >
            <source
              src="/images/tia-paty/video-tia_paty-home.m4v"
              type="video/mp4"
            />
            Seu navegador não suporta vídeo HTML5.
          </video>

          <Div className="tp-hero-overlay" />

          {/* Controles de Vídeo */}
          <Div className="tp-video-controls">
            <button className="tp-control-btn" onClick={togglePlay}>
              <Icon icon={isPlaying ? "bi:pause-fill" : "bi:play-fill"} />
            </button>
            {/* <button className="tp-control-btn" onClick={toggleMute}>
              <Icon
                icon={isMuted ? "bi:volume-mute-fill" : "bi:volume-up-fill"}
              />
            </button> */}
          </Div>

          {/* Botão Scroll Down */}
          <Div className="tp-video-scroll">
            <a href="#objetivo" className="cs-down_btn">
              .
            </a>
          </Div>
        </Div>
      </Div>
      {/* End Hero Section */}

      {/* Start Objetivo + Galeria Section */}
      <Div id="objetivo" className="tp-bg-light" style={bgObjetivo}>
        <Div className="container">
          <SectionHeading
            title='NOSSO OBJETIVO É <span class="tp-highlight-orange">PROMOVER AUTONOMIA, CONFIANÇA,</span> EQUILÍBRIO EMOCIONAL, ORGANIZAÇÃO CORPORAL E <span class="tp-highlight-orange">QUALIDADE DE VIDA.</span>'
            subtitle=""
            variant="cs-style1 text-center"
          />
          <Spacing lg="90" md="45" />

          <PortfolioSlider variant="cs-style1 cs-type1" />
        </Div>
      </Div>
      {/* End Objetivo + Galeria Section */}

      {/* Start Moving Text Section */}
      <MovingText2 data={serviceData1} />
      <Spacing lg="15" md="10" />
      <MovingText2 reverseDirection data={serviceData2} />
      {/* End Moving Text Section */}

      {/* Start Vídeos Section */}
      <Div className="tp-bg-light" style={bgObjetivo}>
        <Div className="container">
          <SectionHeading
            title="Conheça nosso trabalho"
            subtitle=""
            variant="cs-style1 text-center"
          />
          <Spacing lg="70" md="45" />
          <Div className="justify-content-center g-4 tp-videos-grid">
            {videosData.map((video, index) => (
              <Div key={index} className="tp-video-item">
                <VideoModal videoSrc={video.videoSrc} bgUrl={video.bgUrl} />
              </Div>
            ))}
          </Div>
        </Div>
      </Div>
      {/* End Vídeos Section */}

      {/* Start Psicomotricidade Section */}
      <Spacing lg="80" md="60" />
      <Div className="container">
        <Div className="row align-items-center tp-psicomotricidade-section">
          <Div className="col-lg-4 col-md-5 col-12 tp-avatar-col">
            <Div className="tp-avatar-wrapper">
              <img
                src="/images/tia-paty/avatar-tia-paty.png"
                alt="Psicomotricidade Tia Paty"
                className="cs-radius_100 tp-avatar-img"
              />
            </Div>
            <Spacing lg="0" md="30" />
          </Div>
          <Div className="col-lg-8 col-md-7 col-12">
            <SectionHeading
              title='"A <span class="tp-highlight-orange">Psicomotricidade</span> estuda a relação entre corpo, movimento, emoção e pensamento. No consultório, isso significa ajudar a criança a <span class="tp-highlight-orange">se expressar,</span> se organizar, ganhar autonomia, confiança e desenvolver habilidades essenciais para o <span class="tp-highlight-orange">dia a dia.</span>"'
              subtitle=""
            />
          </Div>
        </Div>
      </Div>
      {/* End Psicomotricidade Section */}

      {/* Start Button Whatsapp Section */}
      <Div style={bgObjetivo}>
        <Spacing lg="100" md="60" />
        <Div className="container text-center">
          <a
            href="https://api.whatsapp.com/send/?phone=5567992199121&text=Ol%C3%A1+gostaria+de+informa%C3%A7%C3%B5es+sobre+a+sess%C3%A3o+de+psicomotricidade&type=phone_number&app_absent=0"
            className="cs-text_btn tp-whatsapp-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="logos:whatsapp-icon" />
            <span>WHATSAPP - AGENDE SUA ANAMNESE</span>
          </a>
        </Div>
        <Spacing lg="80" md="60" />
      </Div>
      {/* End Button Whatsapp Section */}

      {/* Start Localização Section */}
      <Div className="container tp-localizacao-section">
        <Div className="row g-5">
          <Div className="col-lg-8 col-md-7 col-12">
            <Div className="tp-map-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3693.5964815670754!2d-54.815911388009766!3d-22.217436313516377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9489a9bdfee51fed%3A0x5e190bcd9d9da7!2sMedical%20Center%20Dourados!5e0!3m2!1spt-BR!2sbr!4v1765895436323!5m2!1spt-BR!2sbr"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '300px' }}
                allowFullScreen
                loading="lazy"
                title="Localização Tia Paty"
                className="cs-radius_15"
              />
            </Div>
          </Div>
          <Div className="col-lg-4 col-md-5 col-12">
            <Div className="tp-localizacao-img-wrapper">
              <img
                src="/images/tia-paty/MEDICAL.png"
                alt="Edifício Dourados Medical Center"
                className="cs-radius_15 tp-localizacao-img"
              />
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg="80" md="60" />
      {/* End Localização Section */}
    </>
  );
}
